import apiClient from '@/services/axios'

export async function get(billwerkSubscriptionHandle) {
  var response = await apiClient.get('/Subscription/BillWerk/?billwerkSubscriptionHandle=' + billwerkSubscriptionHandle)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get billwerk subscription')
}